let Widget3dsoft = require('./Main.js');

Widget3dsoft.prototype.init = function (sJWT, sLang, aOptions) {
    this.sVersion = '1.2.47';
    console.log('Widget3DSoft : Initialisation du widget v' + this.sVersion + ' | JQuery v' + $.fn.jquery + ' detected.');

    var self = this;
    //Detect if it's an old version of ie. (window.XDomainRequest exists only on IE9 and less) 
    //The user agent of IE is mozilla so it's useless to try with it
    bIEOld3Dsoft = typeof (window.XDomainRequest) == 'function' || typeof (window.XDomainRequest) == 'object';
    this.appendCSS();

    if (sJWT == undefined || sJWT == null) {
        console.log('Widget3DSoft : Le token est manquant.');
        this.showErrorInitialisation(self);
    } else {
        self.sJWT = sJWT;
        self.sLang = sLang;
        if (self.sLang === undefined) {
            self.sLang = 'en_EN';
        }

        self.setSParamsGet(this);

        self.getSiteConfig(self, function () {

            self.getLanguage(this, function () {
                self.aMois = Array('',
                    self.sLanguage.DATES_MOIS_JANVIER,
                    self.sLanguage.DATES_MOIS_FEVRIER,
                    self.sLanguage.DATES_MOIS_MARS,
                    self.sLanguage.DATES_MOIS_AVRIL,
                    self.sLanguage.DATES_MOIS_MAI,
                    self.sLanguage.DATES_MOIS_JUIN,
                    self.sLanguage.DATES_MOIS_JUILLET,
                    self.sLanguage.DATES_MOIS_AOUT,
                    self.sLanguage.DATES_MOIS_SEPTEMBRE,
                    self.sLanguage.DATES_MOIS_OCTORE,
                    self.sLanguage.DATES_MOIS_NOVEMBRE,
                    self.sLanguage.DATES_MOIS_DECEMBRE
                );

                if (self.oSite.bIdentificationPersonnel === true) {
                    if (sessionStorage.getItem('widget3Dsoft-UserToken') !== null) {
                        self.ajax('POST',
                            self.sServerURL + 'rest/utilisateur/widget-connexion' + self.sParamsGet, {
                                sClientName: self.sClientName,
                                sCfaLibelle: self.sCfaLibelle,
                                widget3DsoftUserToken: sessionStorage.getItem('widget3Dsoft-UserToken'),
                            },
                            function (response) {

                                if (bIEOld3Dsoft) {
                                    response = JSON.parse(response);
                                }
                                if (response.bSuccess == true) {

                                    self.oUser.sUsername = response.oUtilisateur.profil;
                                    self.oUser.nom = response.oUtilisateur.nom;
                                    self.oUser.prenom = response.oUtilisateur.prenom;
                                    self.oUser.iId = response.oUtilisateur.id;
                                    self.rendezvous.iIdUti = self.oUser.iId;


                                    self.showFormSearchClient();

                                } else {

                                    showErrorMessage = true;
                                    self.showFormConnexionUser(showErrorMessage);
                                }

                            }, true);
                    } else {
                        self.showFormConnexionUser(false);

                    }
                } else {
                    this.oUser = {
                        sUsername: null,
                        iId: null,
                        nom: null,
                        prenom: null,
                    }
                    self.rendezvous.iIdUti = null;
                    if (aOptions != undefined && aOptions.sShowTab !== undefined) {
                        self.showFormSearchClient(aOptions.sShowTab);
                    } else {
                        self.showFormSearchClient();
                    }
                }

            });
        });

        self.adaptDimensions(self);
    }

    $(self.sClass).toggleClass('aa');
};

Widget3dsoft.prototype.appendCSS = function () {

    var sTheme = (self.aOptions != undefined && self.aOptions.sTheme != undefined) ? self.aOptions.sTheme + '-' : '';
    var css_link = $("<link>", {
        rel: "stylesheet",
        type: "text/css",
        href: this.sServerURL + 'widget/' + sTheme + this.sCss
    });
    css_link.appendTo('head');
    return;
};

Widget3dsoft.prototype.setSParamsGet = function (self) {
    /*  
     self.sClientName = 'superauto';
     self.sCfaLibelle = 'default';
     self.sParamsGet = '?sClientName='+self.sClientName+'&sCfaLibelle='+self.sCfaLibelle+'&sLang='+self.sLang;
     */
    self.sParamsGet = '?&sLang=' + self.sLang;
    if (undefined != self.aOptions && true == self.aOptions.bDebug) {
        self.sParamsGet += "&XDEBUG_SESSION_START=netbeans-xdebug"
    }

};

Widget3dsoft.prototype.getLanguage = function (self, callback) {
    self = this;
    self.ajax("GET", self.sServerURL + 'rest/language' + self.sParamsGet, {},
        function (response) {
            if (bIEOld3Dsoft) {
                self.sLanguage = JSON.parse(response);
            } else {
                self.sLanguage = response;
            }
            if (typeof (callback) == 'function') {
                callback();
            }
        },
        true
    );
};


Widget3dsoft.prototype.getSiteConfig = function (self, callback) {
    self = this;
    self.ajax("GET", self.sServerURL + 'rest/site' + self.sParamsGet, {},

        function (response) {
            if (bIEOld3Dsoft) {
                self.oSite = JSON.parse(response);
            } else {
                self.oSite = response;
            }

            if (typeof (callback) == 'function') {
                callback();
            }

            window.setTimeout(function () {
                self.getSiteConfig(self);
            }, 43200000); //12h
        },
        true
    );

}

Widget3dsoft.prototype.setLanguage = function (self, lang) {
    self.sLang = lang;
    self.setSParamsGet();
    self.getLanguage(self);
};



Widget3dsoft.prototype.initRdv = function (self) {

    self = this;

    self.updateRdvActif = false;
    if (self.rendezvous == undefined) {
        self.rendezvous = {};
    }
    self.rendezvous.iIdClient = null;
    self.rendezvous.civilite = null;
    self.rendezvous.sNom = null;
    self.rendezvous.sPrenom = null;
    self.rendezvous.telmob = null;
    self.rendezvous.teldom = null;
    self.rendezvous.telbur = null;
    self.rendezvous.email = null;
    self.rendezvous.adresse = null;
    self.rendezvous.cp = null;
    self.rendezvous.ville = null;
    self.rendezvous.iIdVehicule = null;
    self.rendezvous.sImmatriculation = null;
    self.rendezvous.iIdMarque = null;
    self.rendezvous.iIdModele = null;
    self.rendezvous.sVin = null;
    self.rendezvous.iKm = null;
    self.rendezvous.aInterventions = [];
    self.rendezvous.iDureeTotale = 0;
    self.rendezvous.sCommentaire = null;
    self.rendezvous.sDateMec = null;
    self.rendezvous.sDateReception = null;
    self.rendezvous.sDateRestitution = null;
    self.rendezvous.iHeureReception = null;
    self.rendezvous.iHeureRestitution = null;
    self.rendezvous.iIdAtelier = null,
    self.rendezvous.iIdReceptionnaire = null;
    self.rendezvous.iIdVehCourtoisie = null;
    self.rendezvous.vehCourtoisie = null;
    self.rendezvous.bVehiculeRemplacement = null;
    self.rendezvous.bLeClientAttend = null;
    self.rendezvous.aInterventions = [];
    self.rendezvous.aTravaux = [];
    self.aInterventions = [];
    self.aTravaux = [];
    self.iNbSelectInterventions = 0;
};

Widget3dsoft.prototype.factoryCache = function () {




};